<template lang="pug">
    layout

        template
            // Title
            title-component(
                :title="$t('help.title')"
                slot="title"
                type="h2"
            )

        template
            v-container
                v-layout(row wrap justify-space-between)
                    v-flex(xs12)
                        // Logo
                        p(class="logoWrapper")
                            logo-component(type="help")

                    v-flex(class="xs12 helpText")

                        h2(class="text-xs-center pb-3") What do you need help with?

                        div(class="c-form searchWrapper")
                            // Search field
                            v-text-field(
                                class="search-input"
                                append-icon="search"
                                outline
                                v-model="search"
                                @change="find"
                                :label="$t('fields.search')"
                            )

                        p.loginDescription {{ `Need help? Please send an email to ` }}
                            a.loginDescription(
                                href="mailto:info@chillanywhere.com"
                            ) info@chillanywhere.com

                        h3(class="pb-3") General Help Topics

                        p
                            b To sign in to your Chill account:
                            br
                            span To sign in to Chill, you need a Chill account. Learn how to create a Chill account

                        p
                            ol
                                li On &nbsp;
                                    a(href="https://chillanywhere.com/" target="_blank" class="white--text") chillanywhere.com
                                    | ,&nbsp;enter the email address and password you use for your Chill account.
                                li Click &nbsp;
                                    strong LET’S GET STARTED.

                        p
                            b To sign out of your Chill account:
                            ol
                                li On &nbsp;
                                    a(href="https://chillanywhere.com/" target="_blank" class="white--text") chillanywhere.com
                                    | ,&nbsp;click the arrow next to your name in the top right corner.
                                li Click &nbsp;
                                    strong Log out.

                        p
                            b To change your password:
                            ol
                                li On &nbsp;
                                    a(href="https://chillanywhere.com/" target="_blank" class="white--text") chillanywhere.com
                                    | ,&nbsp;click the arrow next to your name in the top right corner.
                                li Click &nbsp;
                                    strong Settings.
                                li Under Password Settings, enter your current password in the Password field.
                                li Enter your New Password in the New Password field.
                                li Confirm your New Password in the Confirm New Password field.

                        p
                            b To re-set your password:
                            br
                            spn Please email your company Champion to request your password to be re-set.

                        p
                            b To access your available meditation sessions:
                            ol
                                li On &nbsp;
                                    a(href="https://chillanywhere.com/" target="_blank" class="white--text") chillanywhere.com
                                    | ,&nbsp;navigate to &nbsp;
                                    strong Meditations
                                    | &nbsp; on the top navigation.
                                li Your available meditation sessions will be displayed.

                        p
                            b To access your meditation statistics:
                            ol
                                li On &nbsp;
                                    a(href="https://chillanywhere.com/" target="_blank" class="white--text") chillanywhere.com
                                    | ,&nbsp;navigate to &nbsp;
                                    strong Statistics
                                    | &nbsp; on the top navigation.
                                li Your statistics from when you started your meditation sessions will be displayed.

                        h3(class="pb-3") Account Privacy


                        p
                            b To cancel subscription:
                            ol
                                li On chillanywhere.com, click the arrow next to your name in the top right corner.
                                li Select “Settings”.
                                li Select "Subscription Details".
                                li Select “Cancel” under the subscription plan drop down menu.

                        p
                            b To update form of payment:
                            ol
                                li Click the arrow next to your name in the top right corner.
                                li Select “Settings”
                                li Select “Subscription”
                                li Select “Change Payment”
                                li Enter new card information
                                li Click “Save”

                        p
                            b To access the mood scale:
                            ol
                                li Choose a meditation video.
                                li Press play.
                                li Mood scale will pop up before the video starts.
                                li Watch the entire video.
                                li Mood scale will pop up after the video has ended.

                        p
                            b To set a daily reminder:
                            ol
                                li Click the arrow next to your name in the top right corner.
                                li Select “Settings”
                                li Select “Reminders”
                                li Customize the notification time by clicking the time.
                                li First select AM or PM
                                li Select hour
                                li Select minute

                        p
                            b To set a Live session reminder:
                            ol
                                li From the home page, under “Join us live”.
                                li Click the three dots labeled “Schedule”.
                                li Scroll to find the live session you wish to attend.
                                li Click the bell icon on the top right corner of the live session card.
                                li The reminder is set to notify you … minutes before the session goes live.

                        p
                            b To cancel subscription via Apple Store:
                            ol
                                li Open the Settings app on your mobile device.
                                li Tap Your AppleID email.
                                li Tap “Subscriptions”.
                                li Select the Chill Anywhere subscription.
                                li Tap “Cancel subscription” to disable it from auto-renewing at the end of the current billing cycle.

                        p
                            b To change monthly subscription to annual:
                            ol
                                li If you subscribed to a monthly subscription and are looking to change to an annual subscription, please reach out to Info@chillanywhere.


                        p
                            b How to navigate the Chill Anywhere app:
                            ol
                                li
                                    a(href="https://www.youtube.com/watch?v=a7XMSLABoSk&list=PLMPGPBXxG_uKBpxxFY6tSiajfQSgQ5n7j&index=1" target="_blank" class="white--text") Click here
                                    span &nbsp; to view a video tutorial.

                        p
                            b How to use the Journal feature:
                            ol
                                li
                                    a(href="https://www.youtube.com/watch?v=23hTWfWAE1A&list=PLMPGPBXxG_uKBpxxFY6tSiajfQSgQ5n7j&index=3" target="_blank" class="white--text") Click here
                                    span &nbsp; to view a video tutorial.

                        p
                            b How to use the Timer feature:
                            ol
                                li
                                    a(href="https://www.youtube.com/watch?v=Acev8GEWvbQ&list=PLMPGPBXxG_uKBpxxFY6tSiajfQSgQ5n7j&index=2" target="_blank" class="white--text") Click here
                                    span &nbsp; to view a video tutorial.

                        p
                            router-link(a to="/privacy" class="white--text") Privacy

                        // Back link
                        p
                            router-link(:to="{ name: 'dashboard' }" class="white--text") {{ $t('general.back') }}
</template>

<script>
    import Layout from '../Layout/Layout';
    import Logo from '~components/Logo';
    import Title from '~components/Title';
    import Handler from '~services/Handler';
    import i18n from '../../../i18n';
    import Mark from 'mark.js';

    export default {
        components: {
            Layout,
            TitleComponent: Title,
            LogoComponent: Logo
        },
        data() {
            return {
                search: null
            };
        },
        methods: {
            find: function() {
                const searchMessage = i18n.t('help.searchMessage');

                // The current index of the focused element
                let currentIndex;
                // Top offset for the jump (the search bar)
                let offsetTop = 50;
                // The class that will be appended to the current focused element
                let currentClass = 'current';
                // The context where to search
                let content = document.querySelector('.helpText');
                // jQuery object to save <mark> elements
                let results;

                // Create an instance of mark.js and pass an argument containing
                // the DOM object of the context (where to search for matches)
                let markInstance = new Mark(content);

                // The query what to search
                let keyword = this.search;

                // Determine selected options
                var options = {};
                var optionInputs = {};

                /**
                 * Jumps to the element matching the currentIndex
                 */
                function jumpTo() {
                    if (results.length) {
                        let position,
                            current = results[0];

                        results[0].classList.remove(currentClass);
                        if (results.length) {
                            results[0].classList.add(currentClass);
                            position = current.offsetTop - offsetTop;
                            window.scrollTo(0, position);
                        }
                    } else {
                        Handler.handleResponse(
                            { ok: true },
                            searchMessage,
                            null,
                            undefined
                        );
                    }
                }

                [].forEach.call(optionInputs, function(opt) {
                    options[opt.value] = opt.checked;
                });

                // Remove previous marked elements and mark
                // the new keyword inside the context
                markInstance.unmark({
                    done: function() {
                        markInstance.mark(keyword, {
                            separateWordSearch: true,
                            done: function() {
                                results = content.getElementsByTagName('mark');
                                currentIndex = 0;

                                jumpTo();
                            }
                        });
                    }
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .loginDescription
        text-align: center
        font-weight: 700
        color: #fff
        font-size: 18px
        text-shadow: 0 0 5px #0d47a1

    .logoWrapper
        text-align: center
        max-width: 100%

    .searchWrapper
        width: 280px
        max-width: 100%
        margin: 0 auto

    a
        font-size: 14px

    ol li
        line-height: 20px

    ::selection
        color: black
        background: yellow

    .highlightText
        color: black
        background: yellow
</style>
